<template>

  <span id="back-to-student-ui-button-area" v-if="displayBackButton">
    <form ref="form_ref" method="POST" @submit.prevent="submit">
      <ion-button fill="clear" type="submit">{{textHome}}  <arrow-icon css-class="arrow-right" data-cy="dashboard-btn"></arrow-icon> </ion-button>
    </form>
  </span>
</template>

<script>
import {IonButton, IonCol, IonIcon, IonRow} from '@ionic/vue';
import {computed, defineComponent, getCurrentInstance, reactive, ref} from 'vue';
import HtmlContent from "./HtmlContent";
import constant from "../../constant";
import store from "@/store";
import authHandler from "../../router/authHandler";
import ArrowIcon from "../icons/ArrowIcon";


export default defineComponent({
  name: 'BackToStudentUiButton',
  components: {
    ArrowIcon,
    IonIcon,
    IonCol,
    IonRow,
    HtmlContent,
    IonButton,
  },
  props: {},
  setup(props, ctx) {
    const form_ref = ref([]);
    const state = reactive({
      language_set: store.getters.languageSet,
    });
    const access_token = store.getters.accessToken;
    const return_url = constant.STUDENT_GO_BACK_URL;

    // get current instance just like this
    const internalInstance = getCurrentInstance();
    let globalEmitter = internalInstance.appContext.config.globalProperties.$globalEmitter


    let displayBackButton = computed(() => {

      if (store.getters.groupType == constant.GROUP_TYPE_GROUP && store.getters.previewMode != true) {
        // hide when monitoring is on and test is in progress
        if((store.getters["Monitoring/isMonitoringBrowserEnabled"]===true || store.getters['Monitoring/isMonitoringCameraEnabled'] == true ) && store.getters.testState === constant.STATUS_TEST_IN_PROGRESS){
          return false;
        }
        return true;

      }
      return false;
    })


    function submit() {

      globalEmitter.emit('go_back_to_student_menu');

      setTimeout(()=>{
        // create hidden field to inject access token;
        var token_input = document.createElement("input");
        token_input.setAttribute('type', 'hidden');
        token_input.setAttribute('name', 'token');
        token_input.setAttribute('value', access_token);

        // append hidden field to form
        form_ref.value.appendChild(token_input);
        // set url
        form_ref.value.action = return_url;

        //delete cookie before redirect
        let quiz_id = store.getters.quizId;
        let test_settings = store.getters.testSettings;

        if(test_settings?.proctor_camera_mode === false){
          //When camera proctoring mode is not enabled, then don't delete the token.
          authHandler.deleteToken(quiz_id);
        }
        // submit the form
        form_ref.value.submit();

      }, 300);
    };


    const textHome = computed(()=>{

      return state.language_set.title_bar ?? 'My Tests'
    })

    return {state, return_url, submit, form_ref, displayBackButton, textHome};


  },


});
</script>

<style lang="scss" scoped>

#back-to-student-ui-button-area {
  ion-button {
    //width: 190px;
    width: fit-content;
    height: 22px;

    font-family: 'Helvetica';
    font-style: normal;
    font-weight: 400;
    font-size: 12px;
    line-height: 22px;

    /* identical to box height, or 183% */

    align-items: center;
    text-align: center;
    letter-spacing: 0.02em;

    color: #{variables.$color-gray-secondary};
    --background: transparent;
  }
}

.arrow-right{
  color:#{variables.$color-gray-secondary};
  height:8px;
}

</style>